import React from "react";
import { labelClassName } from "@toolkit/design";
import { cn } from "../../lib/utils";

type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(labelClassName, "leading-none", className)}
      {...props}
    />
  ),
);

Label.displayName = "Label";
